import { render, staticRenderFns } from "./SandboxTemplateCreate.vue?vue&type=template&id=51a040f0&scoped=true&"
import script from "./SandboxTemplateCreate.vue?vue&type=script&lang=js&"
export * from "./SandboxTemplateCreate.vue?vue&type=script&lang=js&"
import style0 from "./SandboxTemplateCreate.vue?vue&type=style&index=0&id=51a040f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a040f0",
  null
  
)

export default component.exports